export default async function hexdigest (algo = 'SHA-256', string = '') {
  const utf8 = new TextEncoder().encode(string)
  const hashBuffer = await crypto.subtle.digest(algo, utf8)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, '0'))
    .join('')
  return hashHex
}
